import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, Subject, throwError, timeout, TimeoutError } from 'rxjs';
import { AuthService } from './auth.service';
import { ChatMessage, ChatMessages } from 'src/core/types/chat.types';

@Injectable({
    providedIn: 'root'
})
export class HistoryService {

    history = new BehaviorSubject<void>(undefined);

    constructor(private http: HttpClient, private authService: AuthService) { }

    private stripAccountId<T>(payload: T): T {
        if (Array.isArray(payload)) {
            return payload.map((item) => this.stripAccountId(item)) as T;
        }

        if (payload && typeof payload === 'object') {
            const { accountId, ...rest } = payload as Record<string, unknown>;
            return rest as T;
        }

        return payload;
    }

    addMessageArray(newChatMessage) {
        return this.http.put<ChatMessage[]>(`${window.location.protocol}//${window.location.hostname}${window.location.port !== "" ? ":" + "8080" : ""}/data/updateChat`, this.stripAccountId(newChatMessage)).pipe(
            timeout(60000), catchError(error => {
                if (error instanceof TimeoutError) {
                    console.error('Request timed out after 60s');
                }
                return throwError(() => error);
            }))
    }

    retrieveChatHistory() {
        return this.http.get<ChatMessages[]>(`${window.location.protocol}//${window.location.hostname}${window.location.port !== "" ? ":" + "8080" : ""}/data/getChats`).pipe(
            timeout(60000), catchError(error => {
                if (error instanceof TimeoutError) {
                    console.error('Request timed out after 60s');
                }
                return throwError(() => error);
            }))
    }

    deleteChat(body) {
        return this.http.put(`${window.location.protocol}//${window.location.hostname}${window.location.port !== "" ? ":" + "8080" : ""}/data/deleteChat`, this.stripAccountId(body)).pipe(
            timeout(30000), catchError(error => {
                if (error instanceof TimeoutError) {
                    console.error('Request timed out after 30s');
                }
                return throwError(() => error);
            }))
    }

    getSingleChat(uid) {

        let body = {
            "chatId": uid
        };

        return this.http.put<ChatMessage[]>(`${window.location.protocol}//${window.location.hostname}${window.location.port !== "" ? ":" + "8080" : ""}/data/getChat`, body).pipe(
            timeout(30000), catchError(error => {
                if (error instanceof TimeoutError) {
                    console.error('Request timed out after 30s');
                }
                return throwError(() => error);
            }))
    }

    generateUID(length = 10) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let uid = '';
        const randomValues = new Uint8Array(length);

        // Populate the array with cryptographically secure random numbers
        crypto.getRandomValues(randomValues);

        let result = '';
        for (let i = 0; i < length; i++) {
            // Use the random number to pick a character from the 'chars' string
            result += chars[randomValues[i] % chars.length];
        }

        return result;
    }
}